module.exports = __webpack_public_path__ + "static/media/x-icon.5f88cdd3.svg";